import MyPurchasedDigitalProducts from "%/dynamic-component-editor/standard-elements/MyPurchasedDigitalProducts.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyMyPurchasedDigitalProducts extends LegacyEntity {
  get elements() {
    return {
      MyPurchasedDigitalProducts,
    };
  }
}
